import {usePlantConfig} from '@domain/shifthandover'
import {UseMutationResult} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {CreateOilAnalysisMaintenanceNotificationActionDto, OilAnalysisActionDto} from '../../types'

import {OilAnalysisCreateMaintenanceNotificationDialogContent} from './OilAnalysisCreateMaintenanceNotificationDialogContent'

type OilAnalysisCreateMaintenanceNotificationDialogProps = {
  event: OilAnalysisActionDto
  plantId: string
  showDialog: boolean
  setDialog: (state: boolean) => void
  createNotification: UseMutationResult<
    string,
    AxiosError,
    CreateOilAnalysisMaintenanceNotificationActionDto
  >
}

export const OilAnalysisCreateMaintenanceNotificationDialog: React.FC<
  OilAnalysisCreateMaintenanceNotificationDialogProps
> = ({event, plantId, setDialog, createNotification: createNotificationProp}) => {
  const createNotification = (notification: CreateOilAnalysisMaintenanceNotificationActionDto) => {
    createNotificationProp.mutate({
      ...notification
    })
    setDialog(false)
  }

  const {i18n} = useTranslation(FEATURE_NAMESPACE)
  const {data} = usePlantConfig({plantId, language: i18n.language})

  if (!data) {
    return null
  }

  return (
    <OilAnalysisCreateMaintenanceNotificationDialogContent
      onClose={() => {
        setDialog(false)
      }}
      plantId={data.plantId}
      workCenters={data.workCenters}
      open={true}
      onConfirm={createNotification}
      event={event}
    />
  )
}
